/* eslint-disable no-new */
import Navigation from './modules/Navigation';
import LawyerSlider from './modules/LawyerSlider';
import JokeSlider from './modules/JokeSlider';
import JudgmentSlider from './modules/JudgmentSlider';
import ContactForm from './modules/ContactForm';
import LeafletMap from './modules/LeafletMap';
import 'mdn-polyfills/Element.prototype.closest';
import 'svg-classlist-polyfill';
import 'svgxuse';

new Navigation();
new ContactForm();
new LeafletMap();

if (document.querySelector('#lawyers')) {
  new LawyerSlider();
}

if (document.querySelector('#jokes')) {
  new JokeSlider();
}

if (document.querySelector('#judgments')) {
  new JudgmentSlider();
}

// eslint-disable-next-line
import style from '../scss/logo-center.scss';
